import * as React from 'react'
import { ReactElement, useContext, useEffect, useState } from 'react'
import { AppContext } from "../../../Context/AppContext"
import { SmartVisionPostier } from "./Postier"
import { Search } from '../../Search'
import "./smartvision.scss";
import { UserAppPostier } from '../UserApp/Postier'
import '../Client/style.scss'
import { postier } from '../Client/postier'
import { Client } from '../Client'

export interface IUser {
    ID: number,
    Username: string
}

export function SmartVision(): ReactElement {

    const { token, setErrors, siteList, client } = useContext(AppContext);

    const [fields, setFields] = useState({ user_ids: [], sites: [], roles: [] });

    const [userList, setUserList] = useState<IUser[]>([]);    
    const [filteredList, setFilteredList] = useState<IUser[]>([])
    const [filteredSiteList, setFilteredSiteList] = useState<string[]>([])
    const [clientInfo, setClient] = useState<Client>({code: '', address: '', database: '', Usersapp: [], name: '', port: 0})

    useEffect(() => {
        UserAppPostier.getUserList(token, "SmartVisionAdminTool", setUserList)
    }, [])

    useEffect(() => {
        postier.getClient(token, client.split(':')[3], setClient, setErrors)
    }, [client]);

    useEffect(() => {
        setFilteredList(userList);
    }, [userList]);

    useEffect(() => {
        setFilteredSiteList(siteList);
    }, [siteList]);

    const validate = () => {
        const body = {
            client: client.split(':')[1],
            database: clientInfo.database,
            port: clientInfo.port,
            sites: fields.sites.map(site => parseInt(site.split(':')[0])),
            address: clientInfo.address,
            user_ids: fields.user_ids,
            roles: fields.roles.join(),
            apiId: 1
        }

        SmartVisionPostier.createRole(token, body, setErrors)
    }

    const handleCheck = (e) => {
        const fieldsCopy = { ...fields }
        const value = e.target.id === "user_ids" ? parseInt(e.target.value) : e.target.value
        if (e.target.checked) {
            fieldsCopy[e.target.id].push(value)
        } else {
            const index = fieldsCopy[e.target.id].indexOf(value)
            fieldsCopy[e.target.id].splice(index, 1)
        }
        setFields(fieldsCopy)
    }

    const handleSelectAll = (e) => {
        const checkedGlobal = e.target.checked;
        const fieldsCopy = { ...fields };

        if (checkedGlobal) {
            filteredList.map((user) => {
                !fieldsCopy[e.target.id].includes(user.ID) && fieldsCopy[e.target.id].push(user.ID)
            });
        } else {
            fieldsCopy[e.target.id].length = 0
        }

        setFields(fieldsCopy)
    };

    const handleSelectAllSites = (e) => {
        const checkedGlobal = e.target.checked;
        const fieldsCopy = { ...fields };

        if (checkedGlobal) {
            filteredSiteList.map((site) => {
                !fieldsCopy[e.target.id].includes(site) && fieldsCopy[e.target.id].push(site)
            });
        } else {
            fieldsCopy[e.target.id].length = 0
        }

        setFields(fieldsCopy)
    };

    return (
        <div className="form-client">
            <h2>Roles SmartVision</h2>
            <div className="line"></div>
            <div className="cont">
                <label>Chercher un utilisateur</label>
                <Search needle={userList} setFilteredList={setFilteredList} searchParam={"Username"} style={{width: '90%', border: '1px solid black'}} />

                <label>Utilisateurs</label>
                <div className="sites">
                    <span>Tout sélectionner</span>
                    <input type="checkbox" onClick={handleSelectAll} id="user_ids" />
                    {filteredList.map((user, index: number) => {
                        return user.database === client.split(':')[0] && <div key={index}><input type="checkbox" checked={fields.user_ids.includes(user.ID)} onChange={handleCheck} value={user.ID} id="user_ids" />{user.username}</div>
                    })}
                </div>

                <label>Chercher un site</label>
                <Search needle={siteList} setFilteredList={setFilteredSiteList} searchParam={""} style={{width: '90%', border: '1px solid black'}} />

                <label>Sites</label>

                <div className="sites">
                <span>Tout sélectionner</span>
                    <input type="checkbox" onClick={handleSelectAllSites} id="sites" />
                    {filteredSiteList.map((site: string, index: number) => {
                        return <div key={index}><input type="checkbox" checked={fields.sites.includes(site)} onChange={handleCheck} id="sites" value={site} />{site.split(':')[1]}</div>
                    })}
                </div>

                <label>Préférence d'affichage</label>
                <div>
                    <input type="checkbox" onClick={handleCheck} value="event" id="roles" />
                    Évènements
                    <input type="checkbox"onClick={handleCheck} value="hour" id="roles" />
                    Horaires
                </div>
            </div>
            <button onClick={validate}>Enregistrer</button>
        </div>
    )
}
